/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-media-manager',
    'pip-media-360-player',
    'pip-events',
    'thdSlider',
    'thd-videoPlayer',
    'iscroll5',
    'breakpoints'
],
function(
    $,
    Mustache,
    pip,
    pipMediaManager,
    pipMedia360Player,
    pipEvents,
    thdSlider,
    videoPlayer,
    IScroll,
    breakpoints
){

	var templates = {
		overlay: $('#media__expanded_view').html(),
		overlay_thumbnails: $('#media__overlay_thumbnails').html(),
		overlay_main_image: $('#media__overlay_main_image').html()
	};

	var mediaExpandedView = {
        listenersInitialized: false,

		build: function build(target){
			var renderedOverlay = Mustache.render(templates.overlay, {brand: pip.products.primary.data.info.brandName, title:pip.products.primary.data.info.productLabel});
            $('body').append(renderedOverlay);
			$('#grayout').fadeTo(600,'0.6');
			$('#mediaOverlay').fadeIn(600);
			this.renderThumbnails();
			this.addMediaThumbnailIcons();
            this.selectThumbnail();
			this.renderView();
            var autoplay = !(pipMediaManager.active.video && target.className === 'media__thumbnail-count');
            this.viewers[pipMediaManager.active.type.toLowerCase()].init(autoplay);
			this.initEventListeners();
			this.setMainImageSize();
		},

		addMediaThumbnailIcons: function addMediaThumbnailIcons() {
			$('.overlayThumbnail').each(function(){
				var mediaType = $(this).data('media_type');
				if(mediaType === 'VIDEO'){
					$(this).prepend('<span class="videoIcon"></span>');
				}
				if(mediaType === 'THREESIXTY'){
					$(this).prepend('<div class="whiteout"></div><span class="threesixtyIcon"></span>');
				}
			});
		},

		selectThumbnail: function (selector){
			selector = selector || '.overlayThumbnail';
			$(selector).removeClass('overlayThumbnail--selected');
			$(selector + '[data-media_id="' + pipMediaManager.active.id + '"]').addClass('overlayThumbnail--selected');
		},

		renderThumbnails: function renderThumbnails(){
			var renderedHtml = Mustache.render(templates.overlay_thumbnails, {thumbnails: pipMediaManager.getThumbnails()});
			$('#overlay-body-right').html(renderedHtml);
			$('#overlayThumbnails').append('<div class="clearfloat"></div>');
		},

		setImageCaption: function setImageCaption(container, text){
			$('.image-caption', container).html(text);
		},

		set360Caption: function set360Caption(){
			var caption = mediaExpandedView.isIOS() && pip.features.pinchToZoomEnabled
        ? 'Drag to Spin | Pinch Image to Zoom'
        : 'Drag to Spin | Click Image to Zoom';
			mediaExpandedView.setImageCaption('#overlay-body', caption);
			if(pip.platform !== 'TABLET') mediaExpandedView.setImageCaption('#inline_player_container', caption);
		},

		renderView: function() {
      var view = {
        media: pipMediaManager.active,
        threeSixtyImageLoadFixEnabled: pip.features.threeSixtyImageLoadFixEnabled
      };
      $('#overlay-main-image-container').html(Mustache.render(templates.overlay_main_image, view)).fadeIn(300);
		},

		setMainImageSize: function setMainImageSize(){
            var overlayBodyHeight = $('#overlay-body').height();
            var overlayBodyTopHeight = $('#overlay-body-top').outerHeight(true);

            // TODO: Current layout requires knowledge of the breakpoint to calc the correct height on image container ancestor.  Try to find
            // a means of laying the overlay out that doesn't require this!  Note: I've tried applying flexbox down to the zoom wrapper, but that
            // first attempt was a failure.
            var overlayBodyRightHeight = breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small') ? $('#overlay-body-right').outerHeight() : 0;
            var imageCaptionHeight = $('.image-caption').outerHeight(true);
            var overlayMainImageContainerHeight = overlayBodyHeight - overlayBodyTopHeight - imageCaptionHeight - overlayBodyRightHeight;
            $('#overlay-main-image-container').css('height', (overlayMainImageContainerHeight) + 'px');

            // Now that we've established a height on the ancestor container, we need to ensure the non-zoom view is
            // properly dimension-ed for centering purposes.
            var $normalImageWrapper = $('#mediaOverlay .normalImageWrapper');
            var normalImageWrapperWidth = $normalImageWrapper.width();
            // TODO: This sucks that we're reaching into the viewer to make this determination, and also not clear that
            // what we're really .  Have to refactor this.
            if (!mediaExpandedView.viewers.image.isZoomView()
                    && overlayMainImageContainerHeight > normalImageWrapperWidth) {
                $normalImageWrapper.css('height', normalImageWrapperWidth);
                var normalImageWrapperPaddingTopAndBottom = (overlayMainImageContainerHeight - normalImageWrapperWidth)/2;
                $normalImageWrapper.css('padding', normalImageWrapperPaddingTopAndBottom + 'px 0');
            }

		},

		getOverlaySize: function getOverlaySize(){
			var height = $('#mediaOverlay').height() - ($('#overlay-body-top').height() + 25);
			var width = $('#overlay-body-left').width() - 50;
			return {
				height: height,
				width: width,
				squareSize: width > height ? height : width
			}
		},

    isIOS: function isIOS() {
      var iOSCheck = /iPad|iPhone|iPod/.test(navigator.platform)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (iOSCheck) return true;
      return false;
    },

		viewers: {
			image:{
				isZoomed: false,
        iscrollConfig: null,
        ZOOMED_OUT_CAPTION: 'Click or Tap Image to Zoom In',
        ZOOMED_IN_CAPTION: 'Click or Tap Image to Zoom Out',
        ZOOMED_OUT_CAPTION_MOBILE: 'Pinch Image to Zoom In',

				init: function init(){
          var isIOS = mediaExpandedView.isIOS();
					if(pipMediaManager.active.url_1000){
            if (pip.features.pinchToZoomEnabled) {
              if(!isIOS) {
                this.initZoom();
              }
            } else {
              this.initZoom();
            }
						this.prefetchImage(1000);
            var zoomText = isIOS && pip.features.pinchToZoomEnabled
              ? mediaExpandedView.viewers.image.ZOOMED_OUT_CAPTION_MOBILE
              : mediaExpandedView.viewers.image.ZOOMED_OUT_CAPTION;
            mediaExpandedView.setImageCaption('#overlay-body', zoomText);
					} else {
						mediaExpandedView.setImageCaption('#overlay-body' ,'');
					}
				},
				initZoom: function initZoom(){
                    $('#overlay-body-left .normalImageWrapper').off(TouchMouseEvent.UP).on(TouchMouseEvent.UP,function(touchMouseEvent) {
                        // TODO: Settle on a single term
                        mediaExpandedView.setImageCaption('#overlay-body', mediaExpandedView.viewers.image.ZOOMED_IN_CAPTION);
                        $('.normalImageWrapper').hide();
                        $('.zoomWrapper').show();
                        var scrollerStartCoordinates = mediaExpandedView.viewers.image.getCoordinatesToCenterScroller();
                        this.iscrollConfig = new IScroll('.zoomWrapper', {
                            zoom: true,
                            scrollX : true,
                            freeScroll : true,
                            momentum: false,
                            tap: 'zoomOut',
                            startZoom: mediaExpandedView.viewers.image.getZoomScale(),
                            // startX: -200,
                            // startY: -200
                            startX: scrollerStartCoordinates.x,
                            startY: scrollerStartCoordinates.y//,
                            // zoomMin: .5
                            // which: -1
                            // disablePointer: true
                        });
                    });

                    $('.zoomWrapper').off('zoomOut').on('zoomOut', function zoomOut() {
                        mediaExpandedView.setImageCaption('#overlay-body', mediaExpandedView.viewers.image.ZOOMED_OUT_CAPTION);
                        $('.zoomWrapper').hide();
                        $('.normalImageWrapper').show();
                        mediaExpandedView.viewers.image.removeScroller();
                    });
				},
				prefetchImage: function prefetchImage(size){
					$('<img/>')[0].src = pipMediaManager.active["url_" + size];
				},

                // TODO: Scroller is begging to be turned into its own object with its own methods.
                getZoomScale: function getZoomScale() {
                    return breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small') ? 1.6 : 1;
                },
                rescaleScroller: function rescaleScroller() {
                    if (this.iscrollConfig && this.getZoomScale() !== this.iscrollConfig.startZoom) {
                        this.iscrollConfig.zoom(this.getZoomScale());
                    }
                },
                // For now only using this to init the scroller with a centered view.  The idea being if someone
                // starts scrolling and then they resize, we don't necessarily want to shift the view.  Can examine
                // the need to apply this to resizing at a future date, especially if doing it in a smart fashion.
                // TODO: This method can be simplified, but it's working so not touching it until later.
                getCoordinatesToCenterScroller: function getCoordinatesToCenterScroller() {
				    var zoomedImageWidth, zoomedImageHeight;
                    var $zoomWrapper = $('.zoomWrapper');
				    var zoomWrapperWidth = $zoomWrapper.width();
				    var zoomWrapperHeight = $zoomWrapper.height();
                    if (breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small')) {
                        var zoomScale = this.getZoomScale();
                        // Due to usage of height: 100% on .zoomWrapper, we can reference that to come up with the
                        // dimension of the image as iscroll sees it.  In this code, we're making an assumption of a
                        // square image.
                        var zoomedImageSideLength = zoomWrapperWidth > zoomWrapperHeight ? zoomWrapperWidth : zoomWrapperHeight;
                        // zoomedImageWidth = zoomWrapperWidth * zoomScale;
                        // zoomedImageHeight = zoomWrapperHeight * zoomScale;
                        zoomedImageWidth = zoomedImageSideLength * zoomScale;
                        zoomedImageHeight = zoomedImageSideLength * zoomScale;
                    } else {
                        zoomedImageWidth = 1000;
                        zoomedImageHeight = 1000;
                    }
                    return {
                        x: (zoomWrapperWidth - zoomedImageWidth) / 2,
                        y: (zoomWrapperHeight - zoomedImageHeight) / 2
                    };
                },
                removeScroller: function removeScroller() {
                    $('.zoomWrapper').hide();
                    $('.normalImageWrapper').show();
                    if (this.iscrollConfig) {
                        this.iscrollConfig.destroy();
                        this.iscrollConfig = null;
                    }
                },
                isZoomView: function isZoomView() {
				    return !!mediaExpandedView.viewers.image.iscrollConfig;
                }
			},
			video:{
				init: function init(autoplay){
                    mediaExpandedView.MediaVideoPlayer = videoPlayer.create(pipMediaManager.active.id, {autoplay: autoplay});
                    mediaExpandedView.MediaVideoPlayer.render('#videoPlaceHolderOverlay');
					mediaExpandedView.setImageCaption('#overlay-body' ,'');
				}
			},
			threesixty:{
				threesixtyPlayer: {},
				init: function init(autoplay){
					$('#mediaOverlay .loading_error_msg').hide();
					var playerSize = mediaExpandedView.getOverlaySize();
					if(!mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id] || !mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id].hasFullyLoaded){
						mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id] = pipMedia360Player.create(pipMediaManager.active, playerSize, '#mediaOverlay', autoplay);
					}
					mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id].launch();
					mediaExpandedView.setImageCaption('#overlay-body' ,'');
				},
				replay: function replay(){
					if(!mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id].isLoading && !mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id].isSpinning) {
						mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id].autoSpin();
					}
				}
			}
		}

	};

	mediaExpandedView.getActiveThreesixtyObject = function getActiveThreesixtyObject(){
		return mediaExpandedView.viewers.threesixty.threesixtyPlayer[pipMediaManager.active.id];
	};

	mediaExpandedView.interruptThreesixtyLoading = function interruptThreesixtyLoading(){
		var activeThreesixtyObject = mediaExpandedView.getActiveThreesixtyObject();
		if(activeThreesixtyObject && activeThreesixtyObject.isLoading){
			clearInterval(activeThreesixtyObject.loadingTimer);
			$.each(activeThreesixtyObject.loadingImages, function(key,val){
				val.onload = null;
			});
			delete activeThreesixtyObject;
		}
	};

	mediaExpandedView.cleanupVideos = function cleanupVideos(){
        if(mediaExpandedView.MediaVideoPlayer) delete mediaExpandedView.MediaVideoPlayer;
	};

	mediaExpandedView.initEventListeners = function initEventListeners(){

        if(mediaExpandedView.listenersInitialized) return;
        mediaExpandedView.listenersInitialized = true;

 		$(document).off('.mediaPlayer');

		$(document).on('click.mediaPlayer, tap.mediaPlayer', '.overlayThumbnail', function(e) {
            e.preventDefault();
			mediaExpandedView.interruptThreesixtyLoading();
			mediaExpandedView.cleanupVideos();
            mediaExpandedView.viewers.image.removeScroller();

			if($(this).data('media_id') === pipMediaManager.active.id && pipMediaManager.active.type === 'THREESIXTY'){
				mediaExpandedView.viewers.threesixty.replay();
			} else if($(this).data('media_id') !== pipMediaManager.active.id){
				pipMediaManager.updateActiveMedia($(this).data('media_id'), $(this).data('media_type'));
				mediaExpandedView.renderView();
				mediaExpandedView.selectThumbnail('.overlayThumbnail');
				mediaExpandedView.viewers[$(this).data('media_type').toLowerCase()].init(true);
				mediaExpandedView.setMainImageSize();
			}
		});

		$(document).on('click.mediaPlayer','#grayout,#overlay-close',function(e){
			e.preventDefault();
			mediaExpandedView.cleanupVideos();
			pipEvents.media.closeMediaView.trigger({eventName: 'closed expanded view'});
			$('#grayout,#mediaOverlay').fadeOut('fast',function(){
				$(this).remove();
			});
			// if(pip.platform === 'TABLET'){
			// 	$('html, body').removeClass('noPageScroll');
			// 	$('#oo_tab').show();
			// }
		});

		pipEvents.threeSixty.threeSixtyAutoSpinComplete.on(function(){
			var activeThreesixtyObject = mediaExpandedView.getActiveThreesixtyObject();
			if(activeThreesixtyObject && !activeThreesixtyObject.isLoading && !activeThreesixtyObject.isSpinning){
				mediaExpandedView.set360Caption();
			}
		});

		pipEvents.threeSixty.threeSixtyTimeoutThresholdReached.on(function(){
			$('#mediaOverlay .loading_error_msg').show();
		});

		$(document).keydown(function(e) {
	        var code = e.keyCode;
	        if (code === 27 && $('#mediaOverlay').length) {
	            $("#mediaOverlay #overlay-close").trigger("click");
	        }
	    });

		$(window).resize(function(e){
			mediaExpandedView.setMainImageSize();
			mediaExpandedView.viewers.image.rescaleScroller();
		});

	};

	return mediaExpandedView;

});

}.call(window));